import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
// import Button from "@mui/material/Button";
import {ReactComponent as Edit}from "../../../../../assets/images/edit.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import styles from "./style";
// import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";


const PensionList = ({data,page,setPage,total,handleDelete, setFrom,setOpen,setItem, }) => {

  const [rowsPerPage, setRowsPerPage] = useState(10);

  // const navigate = useNavigate()

  const handleNavigate = (item) => {
    
    setItem(item);
    setOpen(true);
    setFrom("edit");
    // setChange("false");
  }

  const [opens,setOpens] = useState(false);
  const [value, setValue] = useState();

  const deleteData = (item) => {
    setValue(item);

  }
  const handleDeleteItem = () => {
    handleDelete(value); // Call the delete function passed as prop
    setOpens(false); // Close the modal after deleting
  };

  return (
    <>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Pension Type</TableCell>
              <TableCell sx={styles.TableHead}>Employee Type</TableCell>
              <TableCell sx={styles.TableHead}>Employee PayType</TableCell>
              <TableCell sx={styles.TableHead}>Employee Rate</TableCell>

              <TableCell sx={styles.TableHead}>Employer Type</TableCell>
              <TableCell sx={styles.TableHead}>Employer PayType</TableCell>
              <TableCell sx={styles.TableHead}>Employer Rate</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? ( 
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => ( 

                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={item?.employeeDetails?.personalInfo.image} sx={{ mr: "8px" }} /><Box >
                      <Typography sx={styles.name}>{item?.employeeDetails?.personalInfo.firstName}</Typography>
                      <Typography sx={styles.mail}>{item?.email}</Typography>
                    </Box>       </TableCell>                  
                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.type}</TableCell>


                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.employeeCont?.type}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.employeeCont?.payType}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.employeeCont?.rateValue}</TableCell>

                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.employerCont?.type ? item?.contributions?.[0]?.employerCont?.type : "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.employerCont?.payType ? item?.contributions?.[0]?.employerCont?.payType : "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.contributions?.[0]?.employerCont?.rateValue ? item?.contributions?.[0]?.employerCont?.rateValue : "-"}</TableCell>

                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
            
                      <Edit sx={styles.viewIcon} onClick={() => { handleNavigate(item) }}/> 
                      {/* <RemoveRedEyeOutlinedIcon onClick={() => handleNavigateView(item)} sx={styles.viewIcon}/>  */}

                      <DeleteOutlineIcon sx={{ color: "#ff0000", ml: 2 }} onClick={() => { deleteData(item?._id),  setOpens(true);
                      }}/>
                    </Box>

                  </TableCell>
                </TableRow>


              )))}

          </TableBody>

        </Table>

        {data &&
       <CustomPagination
         pageCount={total}         
         page={page}
         setPage={setPage}
         rowsPerPage={rowsPerPage}
         setRowsPerPage={setRowsPerPage}
         totalItems={data.length}
       />} 


      </TableContainer>


      <Modal open={opens} setOpen={setOpens} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Loan"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </>  );
};
export default PensionList;
